import React, { Component } from 'react';
import RichTextEditor from 'react-rte';

const DEFAULT_FORMAT = "markdown";
const className = (props) => {
    if (props.touched && props.error) { return 'form-group has-error' }
    else if (props.touched && props.warning) { return 'form-group has-warning' }
    return 'form-group';
}


export default class RTEWidget extends Component {
    constructor(props) {
        super(props);

        let {
            formData = "",
            uiSchema: { rte: { format = DEFAULT_FORMAT } = {} },            
        } = props;

        this.state = {
            value: RichTextEditor.createValueFromString(formData, format),
            focus: ''
        };
    }

    updateFormData = () => {
        let {
            uiSchema: { rte: { format = DEFAULT_FORMAT } = {} },
            onChange,
        } = this.props;
        let { value } = this.state;
        if (onChange) {
            onChange(value.toString(format));
        }
    };

    handleChange = value => {
        let { uiSchema: { updateOnBlur = false } } = this.props;
        this.setState({ value }, () => !updateOnBlur && this.updateFormData());
    };

    handleBlur = () => {
        let { uiSchema: { updateOnBlur = false } } = this.props;
        if (updateOnBlur) {
            this.updateFormData();
        }
        this.setState({ focus: '' });
    };

    render() {
        let { uiSchema: { rte }, idSchema: { $id } = {} } = this.props;
        let autoFocus = this.props.uiSchema["ui:autofocus"];
        let label = this.props.uiSchema["ui:title"] || this.props.schema.title || this.props.name;
        return (<RTE input={$id} label={label} meta="" rte={rte} autoFocus={autoFocus} myThis={this} required={this.props.required} />)
        
    }
    
}

export const RTE = ({ input, label, meta: { touched, error, warning }, rte, autoFocus, myThis, required }) => (
    
        <div id={input} className={className({ touched, error, warning })}>
        <label className="control-label" htmlFor={input}>{label}{required ? "*" : null}</label>
            <RichTextEditor className={`text-editor ${myThis.state.focus}`}
                onBlur={myThis.handleBlur}
                onFocus={() => {
                    myThis.setState({focus: 'focus'})
                }}
                {...rte}
                autoFocus={autoFocus}
                value={myThis.state.value}
                onChange={myThis.handleChange}
            />
            {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span className="text-warning">{warning}</span>))}
        </div>
    
)